export { AbstractSubscriberComponent } from './abstract-subscriber.component';
